import React from 'react';
import type {SearchFilters} from '../types/api.types';

interface AdvancedFiltersProps {
  filters: SearchFilters;
  onFiltersChange: (filters: SearchFilters) => void;
  onClose: () => void;
  onApply: () => void;
}

export const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  filters,
  onFiltersChange,
  onClose,
  onApply,
}) => {
  const handleChange = (field: keyof SearchFilters, value: string) => {
    onFiltersChange({
      ...filters,
      [field]: value || undefined,
    });
  };

  const handleClear = () => {
    onFiltersChange({});
  };

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 space-y-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Filtros Avanzados</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Radicado
          </label>
          <input
            type="text"
            value={filters.radicado || ''}
            onChange={(e) => handleChange('radicado', e.target.value)}
            placeholder="Ej: PQR-2026-001"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-gray-300"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Radicado de Entrada
          </label>
          <input
            type="text"
            value={filters.radicado_entrada || ''}
            onChange={(e) => handleChange('radicado_entrada', e.target.value)}
            placeholder="Ej: 20242400057492"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-gray-300"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre del Solicitante
          </label>
          <input
            type="text"
            value={filters.nombre_solicitante || ''}
            onChange={(e) => handleChange('nombre_solicitante', e.target.value)}
            placeholder="Ej: CARLOS ARTURO ACOSTA MARÍN"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-gray-300"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            ID de Documento
          </label>
          <input
            type="number"
            value={filters.doc_id || ''}
            onChange={(e) => handleChange('doc_id', e.target.value)}
            placeholder="Ej: 1"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-gray-300"
          />
        </div>
      </div>

      <div className="flex gap-3 pt-4 border-t border-gray-200">
        <button
          onClick={handleClear}
          className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
        >
          Limpiar Filtros
        </button>
        <button
          onClick={onApply}
          className="flex-1 px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
        >
          Aplicar Filtros
        </button>
      </div>
    </div>
  );
};
